/**
 * Service description enricher.
 *
 * Certains services Square ont des descriptions très courtes ou vides.
 * Ce helper injecte un contenu riche pour les services prioritaires,
 * en fallback sur la description brute Square si pas de match.
 *
 * Utilisé par :
 *  - App.js → ServiceModal (page /services)
 *  - BookingPage.jsx → bloc description du service sélectionné
 */
const _normalize = (s) => (s || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

const ENRICHED = {
  numerologie: {
    description: `Ton prénom, ta date de naissance et ton nom recèlent une carte précise de qui tu es et de ce que tu es venu vivre. Reçois ton bilan numérologique sous forme de PDF envoyé par mail — une vraie boussole pour comprendre tes forces, tes défis et les cycles qui rythment ta vie.

✨ Ce que ton bilan contient
• Ton chemin de vie (mission principale)
• Ton objectif de vie
• Tes défis et cycles karmiques
• Ton profil astrologique complet : signe solaire, ascendant, lunaire

📩 Comment ça marche
1. Tu réserves en ligne (35 €)
2. Tu m'envoies tes informations (date + lieu de naissance, nom complet)
3. Tu reçois ton PDF par mail, à lire et relire à ton rythme

💡 Bon à savoir
Le bilan numérologique est une excellente boussole pour mieux te connaître. Pour creuser un sujet précis (amour, carrière, choix à venir), une consultation de voyance sera plus adaptée — beaucoup de mes clients enchaînent les deux.`,
    learnMore: { url: "/numerologie-montelimar", label: "En savoir plus sur la numérologie →" },
  },
};


/** Match le nom d'un service à une clé enrichie (insensible aux accents/casse). */
function _matchKey(name) {
  if (!name) return null;
  const n = _normalize(name);
  if (n.includes("numerologie")) return "numerologie";
  return null;
}

/**
 * Renvoie la description enrichie (ou la brute si pas de match) + le lien
 * "En savoir plus" optionnel.
 *
 * @param {Object} service — l'objet service (avec .name et .description)
 * @returns {{description: string, learnMore: {url: string, label: string} | null}}
 */
export function enrichService(service) {
  if (!service) return { description: "", learnMore: null };
  const key = _matchKey(service.name);
  if (key && ENRICHED[key]) {
    return {
      description: ENRICHED[key].description,
      learnMore: ENRICHED[key].learnMore,
    };
  }
  return { description: service.description || "", learnMore: null };
}
